import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getCookie, getUid } from '../../service/authCookie';
import { checkVisit } from '../../service/checkVisit';
import socket from '../../service/socket';
import priceFormat from '../../utils/showPriceFormat';
import './wallet.css'

const Wallet = () => {

    const { state } = useLocation();
    const { wallet } = state;
    useEffect(()=> {
        socket.emit("viewMessage", {
            location: window.location.href,
            authenticated: getCookie(),
            UID : getCookie() ? getUid() : null
        }, (response) => {
            if(response && response.status === 'New')
            checkVisit(response.uId)
        });
    },[])

    
    return(
        <div className="wallet">
            <div className="container">
                <div className='row'>
                    <div className="col-12">
                        <div className="wallet-layer">
                            <h1 className="mb-4">کیف پول من</h1>
                            <div className="shpping-bag-layer">
                                <div>
                                    <i className="fa fa-shopping-bag mr-1"></i>
                                    <span>موجودی کیف پول</span>
                                    <span className="mx-2">:</span>
                                    <span className="text-muted">{priceFormat(Number(wallet))} تومان</span>
                                </div>
                            </div>
                            <div className="alert alert-success mt-5" role="alert">
                                برای شارژ کیف پولتون باید ضایعات خانگی خوتون رو جمع کنید و برای 
                                فروش به ما بسپارید. 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Wallet;